import moment from 'moment';
import changeLogTypes from '../change-log-types.json';

export default function PmChangeLogItemController(
  $sce,
  $scope,
  $rootScope,
  alerts,
  loaderService,
  utilityService,
  ssDialogService,
  confirmDialog,
  editChangeLogAttributesDialog,
  pmDataService,
  pmSharedModelService,
) {
  const vm = this;

  vm.handleEditChangeAttributesClick = _handleEditChangeAttributesClick;
  vm.handleRevertChangeClick = _handleRevertChangeClick;
  vm.handleUseRecommendedChangeClick = _handleUseRecommendedChangeClick;

  _activate();
  _initEventListeners();

  /** **************************************************
   * Event Handlers
   */
  function _handleEditChangeAttributesClick() {
    ssDialogService.dialogs.pm.editChangeLogAttributesDialog = ssDialogService.alert(
      editChangeLogAttributesDialog.getOptions({
        changeLogItem: vm.changeLogItem
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.editChangeLogAttributesDialog);
  }

  function _handleRevertChangeClick($event) {
    ssDialogService.dialogs.pm.confirmRevertChangeDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Revert Change?',
        message: 'Are you sure you want to revert the change?',
        handleYesClick: _handleConfirmRevert,
        handleNoClick: _handleCancelRevert,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pm.confirmRevertChangeDialog);
  }

  function _handleConfirmRevert() {
    loaderService.showViewLoader = true;
    return pmDataService.revertChange(vm.changeLogItem.documentChangeLogId).then(() => {
      if (vm.isDocumentScoped) {
        $rootScope.$broadcast('refreshPmChangeLog', { policyDocumentId: vm.changeLogItem.policyDocumentId });
      } else {
        $rootScope.$broadcast('refreshPmChangeLog', {});
      }
      $rootScope.$broadcast('refreshPMDocuments');
      alerts.success('Change successfully reverted.');
      ssDialogService.hide(ssDialogService.dialogs.pm.confirmRevertChangeDialog);
    });
  }

  function _handleCancelRevert() {
    ssDialogService.hide(ssDialogService.dialogs.pm.confirmRevertChangeDialog);
  }

  function _handleUseRecommendedChangeClick() {
    loaderService.showViewLoader = true;
    alerts.warning('Use recommended change not yet implemented');
    loaderService.showViewLoader = false;
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    _initData();
    vm.changeLogItem.breadcrumb = breadcrumb();
  }

  function breadcrumb() {
    return vm.changeLogItem.breadcrumbs.join(' -> ');
  }

  function _initEventListeners() {
    $scope.$on('refreshDocumentChangeLogAudits', (event, opt) => {
      if (opt.documentChangeLogId === vm.changeLogItem.documentChangeLogId) {
        vm.changeLogItem.explanation = opt.documentChangeLogAudit.explanationTo;
        vm.changeLogItem.isMaterialChange = opt.documentChangeLogAudit.isMaterialChangeTo;
        _loadDocumentChangeLogAudits(opt.documentChangeLogAudit);
      }
    });
  }

  function _initData() {
    vm.changeLogItem.createdDate = moment(vm.changeLogItem.createdDate).format('MM-DD-YYYY');

    if (vm.changeLogItem.changeLogTypeId === changeLogTypes.SECTION_BODY.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_SECTION_BODY.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.SECTION_DETAILS.changeLogTypeId
      // || vm.changeLogItem.changeLogTypeId === changeLogTypes.ENDNOTE_TEXT.changeLogTypeId
    ) {
      vm.changeLogItem.expandedPreviousValue = pmSharedModelService.replaceTokens(
        utilityService.stripHtml(vm.changeLogItem.valuePrevious)
      );
      vm.changeLogItem.expandedCurrentValue = pmSharedModelService.replaceTokens(
        utilityService.stripHtml(vm.changeLogItem.valueCurrent)
      );
      const tooltipTruncateLength = 1000;
      const previousValueLength = vm.changeLogItem.expandedPreviousValue.length;
      vm.changeLogItem.previousValueTooltip = previousValueLength > tooltipTruncateLength
        ? `${vm.changeLogItem.expandedPreviousValue.substr(0, tooltipTruncateLength - 1)}&hellip;`
        : vm.changeLogItem.expandedPreviousValue;
      const currentValueLength = vm.changeLogItem.expandedPreviousValue.length;
      vm.changeLogItem.currentValueTooltip = currentValueLength > tooltipTruncateLength
        ? `${vm.changeLogItem.expandedCurrentValue.substr(0, tooltipTruncateLength - 1)}&hellip;`
        : vm.changeLogItem.expandedCurrentValue;
    } else {
      vm.changeLogItem.expandedPreviousValue = vm.changeLogItem.valuePrevious;
      vm.changeLogItem.previousValueTooltip = vm.changeLogItem.valuePrevious;
      vm.changeLogItem.expandedCurrentValue = vm.changeLogItem.valueCurrent;
      vm.changeLogItem.currentValueTooltip = vm.changeLogItem.valueCurrent;
      vm.changeLogItem.expandedBodyTo = pmSharedModelService.replaceTokens(
        utilityService.stripHtml(vm.changeLogItem.bodyTo)
      );
    }

    // vm.changeLogItem.isExpandable = (vm.changeLogItem.changeLogTypeId === changeLogTypes.SECTION_BODY.changeLogTypeId
    //   || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_SECTION_BODY.changeLogTypeId
    //   || vm.changeLogItem.changeLogTypeId === changeLogTypes.SECTION_DETAILS.changeLogTypeId);

    vm.changeLogItem.isRecommendation = (
      vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_SECTION_TITLE.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_SECTION_BODY.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_ENDNOTE_TEXT.changeLogTypeId
    );

    if (vm.changeLogItem.changeLogTypeId === changeLogTypes.VARIABLE_VALUE.changeLogTypeId) {
      vm.changeLogItem.listTitleCssOverride = 'rte-token pm-variable mt4 cd';
    }
    if (
      vm.changeLogItem.changeLogTypeId === changeLogTypes.ENDNOTE_TEXT.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_ENDNOTE_TEXT.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.MASTER_ENDNOTE_CREATED.changeLogTypeId
      || vm.changeLogItem.changeLogTypeId === changeLogTypes.ENDNOTE_CREATED.changeLogTypeId
    ) {
      vm.changeLogItem.listTitleCssOverride = 'rte-token pm-endnote mt4 cd';
    }

    // const changedBy = vm.changeLogItem.isRecommendation ? 'Navanta' : vm.changeLogItem.createdUserName;
    // const recommendedText = vm.isAcceptedRecommendedChange ? ' per recommendation' : '';
    //
    // vm.changeLogItem.changeDetailsTooltip = `${vm.changeLogItem.changeLogTypeName} was changed by ${changedBy} on
    // ${vm.changeLogItem.createdDate}${recommendedText}.`;

    if ((vm.changeLogItem.changeLogTypeName === 'Section Created')
      || (vm.changeLogItem.changeLogTypeName === 'Document Approved Date')
      || (vm.changeLogItem.changeLogTypeName === 'Section Deleted')
      || (vm.changeLogItem.changeLogTypeName === 'Document Section Code')) {
      vm.changeLogItem.isRevertable = false;
    } else {
      vm.changeLogItem.isRevertable = true;
    }
  }

  function _loadDocumentChangeLogAudits(documentChangeLogAudit) {
    loaderService.showViewLoader = true;
    return pmDataService.getDocumentChangeLogAuditsByDocumentChangeLog(vm.changeLogItem.documentChangeLogId)
      .then((response) => {
        loaderService.showViewLoader = false;
        vm.changeLogItem.isMaterialChange = documentChangeLogAudit.isMaterialChangeTo;
        vm.changeLogItem.materialChange = documentChangeLogAudit.explanationTo;
        vm.changeLogItem.documentChangeLogAudits = response.data.result;
        vm.changeLogItem.documentChangeLogAuditCount = response.data.result.length;
      });
  }
}

PmChangeLogItemController.$inject = [
  '$sce',
  '$scope',
  '$rootScope',
  'alerts',
  'loaderService',
  'utilityService',
  'ssDialogService',
  'confirmDialog',
  'editChangeLogAttributesDialog',
  'pmDataService',
  'pmSharedModelService',
];
